"use strict"

let ComboBox;
let jQuery;

export class jQ {
    
    static init(cb) {
        ComboBox=cb;
        jQuery=new jQ;
        jQ.makeJQuery();
    }

    static makeJQuery() {
        //// nastavení DOM data atributu při $(element).data(key, val)
        //// staré obsluhy používaly jQuery pro změnu ajax url
        //// edit -- dělalo to bordel; tedy -- pouze u ajaxových inputů, nad nimiž existuje combobox
        //// pro všechny případy, kdyby zase někoho napadlo nejdřív dělat kraviny a pak teprve zavádět combobox..... si udělám init nad výchozí třídou
        try {
                        
            var neco=$.fn.data;
            $.fn.extend(
                {data:function(name){
                        var arg=arguments;
                        if ((typeof arg[0] == 'string')&&arg[0]&&(typeof arg[1] !== 'undefined')) {
                            this.each(function(){
                                try {
                                    if (jQ.isAjax(this)) {
                                        if (this.nextElementSibling&&this.nextElementSibling.matches('.new-combobox')) {
                                            this.setAttribute('data-'+arg[0], arg[1]);
                                            console.warn('zastaralá obsluha datasetu comboboxu přes jquery!');
                                        } else if (this.matches('.combobox')) {
                                            window.initCombobox(this);
                                        }
                                    }
                                } catch(e) {}
                            })
                        } else if ((typeof arg[0] == 'object')&&arg[0]) {
                            this.each(function(){
                                var that=this;
                                Object.keys(arg[0]).forEach(function(key){
                                    try {
                                        if (jQ.isAjax(this)) {
                                            if (that.nextElementSibling&&that.nextElementSibling.matches('.new-combobox')) {
                                                that.setAttribute('data-'+key, arg[0][key])
                                                console.warn('zastaralá obsluha datasetu comboboxu přes jquery!');
                                            } else if (this.matches('.combobox')) {
                                                window.initCombobox(this);
                                            }
                                        }
                                    } catch(e) {}
                                });
                            })
                        }
                        return neco.apply(this, arguments)
                    }
                }
            );
            
        } catch(e) {};

        //// zajištění existence $(element).combobox()
        
        try {
            
            $.fn.extend(
                //// pokud existuje alespoň jeden element, předávám buď selector (pokud bylo zadáno selectorem) nebo element (pokud byl zadán element); na ostatní jqueroviny kašleme...
                {combobox:function(a,b,c){if (this[0]) {window.initCombobox(this.selector||this[0], a,b,c)} return this;} }
            
            );
            
        } catch(e) {}
        
    }
    
    static jQuery(element, a,b,c) {
        
        if ((jQuery.input=element)&&(jQuery.combo=element.nextElementSibling)&&element.nextElementSibling.matches('.new-combobox')&&(typeof jQuery[a] === 'function')) { jQuery[a](b,c); }
    }
    
    static isAjax(element) {
        return element.dataset.source||element.dataset.sourceAppend||element.dataset.sourceappend;
    }
    
    setValue(b,c) {
        //if (!b) return;
        
        let target=this.combo.querySelector('input');
        let multi=this.combo.querySelector('.multi-container');
        let input=this.input;
        let value=input.value;
        
        if (input.matches('select')) {
            if (jQ.isAjax(input)) {
                let canAdd=true;
                if (!(input.multiple&&b)) {
                    input.innerHTML='';
                }
                else {
                    let options=input.querySelectorAll('option');
                    for (let i=0, l=options.length; i<l; i++) {
                        if (options[i].value==b) {
                            if (input.matches('.user-sequence')) {input.appendChild(options[i]); canAdd=false;}
                            else {return; } // už je vybrána, nemá smysl se s tím crcat
                        }
                    }
                }
                if (multi) {multi.innerHTML='';}
                if (canAdd&&(b||!input.multiple)) {
                    let option=document.createElement('option');
                    option.value=b;
                    option.innerText=c||b;
                    option.selected='selected';
                    option.setAttribute('selected', 'selected');
                    input.appendChild(option);
                }
                if (input.multiple) {
                    if (multi) {
                        let options=input.querySelectorAll('option');
                        for (let i=0, l=options.length; i<l; i++) {
                            if (input.options[i].selected) {
                                ComboBox.Renderer.addMultiOption(multi, input, input.options[i].value, input.options[i].dataset.short||input.options[i].innerText);
                            }                    

                        }
                    }
                } else {
                    input.value=b;
                    if (target) {target.value=c||b;}
                }
                
            } else {

                let options=input.querySelectorAll('option');

                if (!input.multiple) {
                    let stop=true;
                    for (let i=0, l=options.length; i<l; i++) {
                        if (options[i].value==b) { stop=false; i=l; break; }
                    } 
                    if (stop) return;
                }

                if (input.multiple&&!b) {
                    let e;
                    while (e=input.querySelector('[selected]')) {e.removeAttribute('selected'); e.selected=false;}
                }

                if (multi) {
                    multi.innerHTML='';
                }

                for (let i=0, l=options.length; i<l; i++) {
                    if (options[i].value==b) {
                        c=options[i].dataset.short||options[i].innerText||'';
                        options[i].selected='selected';
                        options[i].setAttribute('selected', 'selected');
                        if (!input.multiple) {
                            input.value=options[i].value;
                            if (target) {target.value=c||b;}
                            if (input.multiple) break;
                        } else if (input.matches('.user-sequence')) {
                            //ComboBox.Renderer.addMultiOption(multi, input, b, c||b);
                            input.appendChild(options[i]);
                        }
                    } else if (!input.multiple) {
                        options[i].selected=false;
                        options[i].removeAttribute('selected');
                    }
                }
        
                if (input.multiple&&multi) {
                    let options=input.querySelectorAll('option');
                    for (let i=0, l=options.length; i<l; i++) {
                        if (input.options[i].selected) {
                            ComboBox.Renderer.addMultiOption(multi, input, input.options[i].value, input.options[i].dataset.short||input.options[i].innerText);
                        }                    
                    }
                }
            }
        } else if (target) {
            target.value=c||b;
            input.value=b;
            
        }
        
        this.combo.classList[input.value&&((target&&target.value)||(input.matches('select')&&input.multiple))?'add':'remove']('combobox-has-value');

        if (input.value!=value) {
            ComboBox.Listener.dispatch(input, 'combo jQuery change');
        }
        
        
    }
    
}
